<!-- TEMPLATE -->
<template>
    <div :class='usersListClass'>
        <div class='row'>
            <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                <dean-section-title content='true'>
                  <span slot='title'>
                    <span class='avenir-heavy'>{{title}}</span>
                  </span>
                  <dean-section-title-item
                    v-if="!showArchive"
                    :icon='archiveIcon'
                    :content="true"
                    @click.native="sectionRoute('partners.users.list.status', {status: 'verwijderd'})"
                  >
                    archief
                  </dean-section-title-item>
                  <dean-section-title-item
                    v-else
                    :icon='returnIcon'
                    :content="true"
                    @click.native="sectionRoute('partners.users.list')"
                  >
                    Terug naar actief
                  </dean-section-title-item>
                  <dean-section-title-item
                    v-if="canCreateUser()"
                    :icon='plusIcon'
                    :content="true"
                    @click.native="sectionRoute('partner.user.add', {pid: $route.params.pid})"
                  >
                    Nieuw
                  </dean-section-title-item>
                </dean-section-title>

                <dean-table
                  :data='usersData'
                  :columns='columns'
                  :hover="true"
                  @column-click='columnClick'
                  @cell-click="cellClick"
                >
                </dean-table>

                <dean-pagination
                  :current-page='usersMetaData.pageNumber'
                  :total-items='usersMetaData.totalResults'
                  :items-per-page='usersMetaData.itemsPerPage'
                  :select-items-per-page='selectItemsPerPage'
                  :visible-pages='usersMetaData.visiblePages'
                  @page-changed='paginationChanged'
                  @items-per-page='itemsPerPageChanged'
                >
                </dean-pagination>
            </div>
        </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';

  import {
    // SVG
    invoicesIcon,
    archiveIcon,
    returnIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';
  import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
  import {UserPrivilege} from "@/enums/UserPrivilege";
  import {UserAction} from "@/enums/UserAction";

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;

    // COMPUTED
    get usersListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get usersMetaData() {
      return this.pageMeta;
    }

    get usersData() {
      return this.data;
    }

    get title() {
      return this.showArchive ? 'Verwijderde gebruikers' : 'Gebruikers';
    }

    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      emailAddress: {
        content: 'E-mailadres',
        align: 'left',
        sort: true,
        dql: 'emailAddress',
      },
      receivesInvoices: {
        content: 'ontvangt facturen',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      receivesNotifications: {
        content: 'ontvangt berichten',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      roles: {
        content: 'Rollen',
        align: 'left',
        sort: false,
      },
    };

    public tableName(): string {
      return 'partner-users';
    }

    public cellClick(target: { cell: object, row: { id: string, organizationId: string }, column: string }) {
      this.$router.push({
        name: 'partner.user.edit',
        params: {userId: target.row.id, pid: target.row.organizationId},
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);
      let userRoles = '';

      const requestUrl: string = '/-/trade/api/partner.contacts.list';

      const requestData: any = {
        id: this.$route.params.pid,
        isUser: true,
        deleted: data.showArchive ? true : null,
      };

      axios.post(requestUrl, requestData)
        .then((response) => {
          const partnerUsersData: any[] = [];
          for (const item of response.data.data) {
            userRoles = '';
            item.roles.forEach((role: any, index: any) => {
              if (index === item.roles.length - 1) {
                userRoles += role.label;
              } else {
                userRoles += role.label + ', ';
              }
            });
            const row = {
              id: item.id,
              organizationId: item.organizationId,
              name: item.name,
              emailAddress: item.emailAddress,
              receivesInvoices: item.receivesInvoices ? 'Ja' : 'Nee',
              receivesNotifications: item.receivesNotifications ? 'Ja' : 'Nee',
              roles: userRoles,
            };
            partnerUsersData.push(row);
          }

          this.data = partnerUsersData;
          this.updateMeta(response.data.meta);
        }).then(
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateUser(): boolean {
      if (authUserHasPrivilegeAndAction(UserPrivilege.USER, UserAction.CREATE)) {
        return true;
      }

      return false;
    }

    public created() {
      this.showArchive = this.$router.currentRoute.params.status === 'verwijderd';

      const data: any = this.pageMeta;
      data.showArchive = this.showArchive;

      this.setDefaultSort('name');
      this.loadList(data);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';
</style>
